"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SideNav = exports.InternalSideNav = exports.UserMenu = void 0;
/** @prettier */
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_redux_1 = require("react-redux");
var SideNav_1 = require("@cjdev-internal/visual-stack/lib/components/SideNav");
var LinkGroup_1 = require("./LinkGroup");
var actions_1 = require("../../actions");
var UserMenu = function (_a) {
    var onLogout = _a.onLogout, label = _a.label, firstInitial = _a.firstInitial, lastInitial = _a.lastInitial, color = _a.color, children = _a.children, logoutLabel = _a.logoutLabel;
    return (react_1["default"].createElement(LinkGroup_1.LinkGroup, { className: "vs-sidenav-user-menu", label: label, icon: react_1["default"].createElement(SideNav_1.UserIcon, { firstInitial: firstInitial, lastInitial: lastInitial, color: color }) },
        children,
        react_1["default"].createElement(SideNav_1.LogoutLink, { onLogout: onLogout, label: logoutLabel })));
};
exports.UserMenu = UserMenu;
var InternalSideNav = /** @class */ (function (_super) {
    __extends(InternalSideNav, _super);
    function InternalSideNav(props) {
        return _super.call(this, props) || this;
    }
    InternalSideNav.prototype.render = function () {
        var userMenuWithColor = this.props.userMenu
            ? react_1["default"].cloneElement(this.props.userMenu, {
                color: this.props.logoBackground
            })
            : null;
        return (react_1["default"].createElement(SideNav_1.SideNav, __assign({ collapsed: this.props.collapsed, onClick: this.props.toggleSideNav, logo: this.props.logo, userMenu: userMenuWithColor }, this.props), this.props.children));
    };
    InternalSideNav.propTypes = {
        collapsed: prop_types_1["default"].bool
    };
    return InternalSideNav;
}(react_1.Component));
exports.InternalSideNav = InternalSideNav;
exports.SideNav = (0, react_redux_1.connect)(function (state) { return ({
    collapsed: state.visualStack.sideNav.collapsed
}); }, {
    toggleSideNav: actions_1.toggleSideNav
})(InternalSideNav);
